import type { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
import type { ButtonSizeType, ButtonVariantType } from '@tundr/ds-components';

export interface NotificationMessage {
  key: string;
  title: string;
  message: string;
  icon?: TUNDR_ICONS;
  dismissable?: boolean;
  variant?: NotificationVariant;
  actions?: (NotificationButtonProps & { onClick?: () => void })[];
}

type NotificationButtonProps = {
  label: string;
  size?: ButtonSizeType;
  variant?: ButtonVariantType;
  [key: string]: unknown;
};

export enum NotificationVariant {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
}
